module.exports = __webpack_public_path__ + "static/img/Examples2.e9a51d5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/followup/Examples2.png
// module id = 0owi
// module chunks = 1